"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./index.common"), exports);
// export Analytics as both a named export and a default export (for backwards-compat. reasons)
const index_common_1 = require("./index.common");
exports.default = index_common_1.Analytics;
//# sourceMappingURL=index.js.map